import isEqual from 'lodash/isEqual';

const getSelectedIndexes = data => selected => {
  if (data === null) return [];
  return selected.map(selectedItem => data.findIndex(item => isEqual(selectedItem, item)));
};

export default getSelectedIndexes;
